import { view } from '@yola/ws-sdk';

const TEXT_SELECTABLE_ATTRIBUTE = 'data-text-selectable';

const makeTextSelectable = (elementId) => {
  const element = view.accessors.getLiveElement(elementId);
  element.setAttribute(TEXT_SELECTABLE_ATTRIBUTE, 'true');
};

const removeTextSelectable = (elementId) => {
  const element = view.accessors.getLiveElement(elementId);
  element.removeAttribute(TEXT_SELECTABLE_ATTRIBUTE);
};

export { makeTextSelectable, removeTextSelectable };
